import { render, staticRenderFns } from "./InputEmpresa.vue?vue&type=template&id=c20f41b0&scoped=true&"
import script from "./InputEmpresa.vue?vue&type=script&lang=js&"
export * from "./InputEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./InputEmpresa.vue?vue&type=style&index=0&id=c20f41b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20f41b0",
  null
  
)

export default component.exports